import*as o from'@radix-ui/react-accordion';var d=o.Root;d.Item=o.Item;d.Header=o.Header;d.Trigger=o.Trigger;d.Content=o.Content;var e=d;export{e as a};//# sourceMappingURL=chunk-H2EUADYZ.js.map
//# sourceMappingURL=chunk-H2EUADYZ.js.map